import styled from "styled-components";

export const Icon = styled.div`
  cursor: pointer;
  transition: ease-in-out 0.3s;
  height: fit-content;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  @media print {
    display: none;
  }

  &:hover {
    transform: scale(1.2);
  }
`;

export const OrgaName = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: #7a89f4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden !important;
  word-break: break-word;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  max-width: 200px;
`;
